import React from 'react';
import { Modal } from '../../admin/Modal';
import { AlertTriangle } from 'lucide-react';

interface RemoveCoachModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  clientName: string;
  coachName: string;
}

export const RemoveCoachModal: React.FC<RemoveCoachModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  clientName,
  coachName
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Remove Coach Assignment?"
      variant="warning"
      size="small"
      footer={
        <>
          <button className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button className="btn btn-danger" onClick={onConfirm}>
            Remove Assignment
          </button>
        </>
      }
    >
      <div style={{ marginBottom: '20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
          <AlertTriangle size={20} color="var(--warning)" />
          <span style={{ fontWeight: '600', color: 'var(--text-primary)' }}>
            Remove {coachName} from {clientName}?
          </span>
        </div>

        <div style={{ marginLeft: '28px', color: 'var(--text-secondary)', fontSize: '14px' }}>
          <p style={{ margin: '8px 0' }}>This will:</p>
          <ul style={{ margin: '8px 0', paddingLeft: '20px' }}>
            <li>Remove the coach-client relationship</li>
            <li>The client will remain in coached mode</li>
            <li>Another coach can be assigned later</li>
          </ul>
        </div>
      </div>
    </Modal>
  );
};
